var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-loader',{attrs:{"height":475,"width":500,"speed":1,"primaryColor":"#f3f3f3","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"26","y":"19","rx":"5","ry":"5","width":"520","height":"520"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }